import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export function OfflineBanner() {
  const { isConnected } = useNetworkStatus();

  if (isConnected) return null;

  return (
    <div className="bg-destructive text-destructive-foreground px-3 py-1.5 text-center text-xs font-medium flex items-center justify-center gap-1.5">
      <WifiOff className="h-3.5 w-3.5" />
      No internet connection
    </div>
  );
}
